import React from 'react';
//import { makeStyles } from '@mui/styles';
import { ThemeProvider } from "@mui/material";
import { responsiveFontSizes, createTheme } from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FaHome, FaPizzaSlice, FaHamburger, FaMapMarkedAlt, FaEuroSign, FaUserTie, FaHospitalUser } from "react-icons/fa";

//import './css/sideBar.scss';
import './css/elements.css';
import './css/dashboard.css';

import Client from './components/Client';
import Config from './components/ClientConfig';
//import Product from './components/Product';
import Employee from './components/Employee';
import EmployeesFilters from './components/EmployeesFilters';

import Visibility from './Visibility';

let theme = createTheme();

class Employees extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      employees: null,
      locationsGroups: [],
      addNewEmployee: false,
      addNewButton: false,
      filterData: {}
    };

    this.applyFilters = this.applyFilters.bind(this);    
    this.toggleAdd = this.toggleAdd.bind(this);
    this.employeeUpdated = this.employeeUpdated.bind(this);
    this.getData = this.getData.bind(this);
    this.restricted = new Visibility ("locations_employees");
  }

  getData () {
    let filterData = {
      ...(this.state.filterData || {})
    };

    if (Object.keys(filterData).length === 0) {
      filterData.country = "country061";
    }

    let employeeQueryData = {
      ...filterData,
      "limit": 20,
      "orderBy_modifiedOn": true
    };

    let data = this.state.client.getData(
      Config.API_URL_EMPLOYEES,
      employeeQueryData
    );

    this.setState({
      employees:
        data && Array.isArray(data.employees)
          ? data.employees
          : [],
      filterData: { ...filterData }
    });

    let groupQueryData = {
      status: 1
    };

    let gdata = this.state.client.getData(
      Config.API_URL_LOCATIONSGROUPS,
      groupQueryData
    );

    this.setState({
      locationsGroups:
        gdata && Array.isArray(gdata.locationsGroups)
          ? gdata.locationsGroups
          : []
    });
  }

  componentDidMount() {
    if (this.restricted.scope.visible)
      this.getData ( );
  }

  componentWillUnmount() {    
  }

  applyFilters ( queryData ) {
    if (queryData) {
      const filterData = {
        ...queryData
      };

      const requestQueryData = {
        ...filterData,
        "limit": 20,
        "orderBy_modifiedOn": true
      };

      let data = this.state.client.filterEmployees(
        requestQueryData
      );

      if (data) {
        this.setState({
          employees: Array.isArray(data.employees)
            ? data.employees
            : [],
          filterData: filterData
        });
      }
    }
  }

  toggleAdd ( ) {
    let doAdd = this.state.addNewEmployee;
    this.setState ( {addNewEmployee: !doAdd} );
    this.setState ( {addNewButton: !doAdd} );
  }

  employeeUpdated ( ) {
    this.setState({
      addNewEmployee: false,
      addNewButton: false
    });

    this.applyFilters(
      this.state.filterData || {}
    );

    window.scrollTo(0, 0);
  }

  render() {
    if (!this.restricted.scope.visible)
      return (<div></div>);
    let employeesList = null;
    let employeesCounter = 0;

    if (Array.isArray(this.state.employees)) {
      employeesCounter = this.state.employees.length;

      if (employeesCounter > 0) {
        employeesList = this.state.employees.map((employee) => {
          const employeeImage =
            employee.person && employee.person.image
              ? employee.person.image
              : "";

          const emp = {
            ...employee,
            image: employeeImage,
            locations: employee.employeeLocation_employee
          };

          return (
            <Employee
              key={employee.iref}
              employee={emp}
              employeeUpdated={this.employeeUpdated}
              addNew={this.state.addNewButton}
              allowEdit={this.restricted.scope.edit}
              geoData={this.props.geoData}
            />
          );
        });
      } else {
        employeesList = (
          <Typography
            variant="body1"
            sx={{
              color: "#e3e3e5",
              textAlign: "center",
              padding: "32px"
            }}
          >
            No employees found
          </Typography>
        );
      }
    }

    let geoData = {};
    if ( this.props.geoData ) geoData = this.props.geoData;
    //let aa = Object.entries ( geoData );

    let countries = {};
    let counties = {};
    Object.keys(geoData).forEach(key => {
      let fData = geoData [ key ];
      countries [ key ] = fData.name;
      //console.log ( fData );
      Object.keys ( fData ).forEach( fKey => {
        if ( fKey !== "name" ) counties [ fKey ] = fData [ fKey ].name;
      });
    });

    let groups = {};
    let locationsGroups = {};
    if ( this.state.locationsGroups ) {
      locationsGroups = this.state.locationsGroups;
      Object.keys(locationsGroups).forEach(key => {
        let fData = locationsGroups [ key ];
        groups [ fData.iref ] = fData.name;
      });
    }    

    return (

 
      <div style={{ backgroundColor: "#273442", height: "100%" }}>
        <div className='sticky'>

          <EmployeesFilters
            key = "ef0"
            applyFilters = {this.applyFilters}
            applyCategory = {this.applyCategory}
            toggleAdd = {this.toggleAdd}
            employeesCounter = {employeesCounter}
            countries = {countries}
            counties = {counties}
            locationsGroups={groups}
            sx={{ position: 'sticky', top: 0}}
            addNew = {this.state.addNewButton}
            allowEdit={this.restricted.scope.edit}
          />

        </div>

        { this.state.addNewEmployee ?
        <Employee
          key="0"
          employee={{}}
          employeeUpdated={this.employeeUpdated}
          addNew={this.state.addNewButton}
          allowEdit={this.restricted.scope.edit}
          geoData={this.props.geoData}
        />
        : ""
        }

        {/* {this.loading ? <Skeleton animation="wave" variant="rounded" width={800} height={400} /> : employeesList } */}
        {employeesList}
      </div>

    );

  }
}

export default Employees;